import React from "react"
import {Link} from "gatsby"
import ProjectSlider from "Layout/Projects/ProjectSlider/ProjectSlider"
import RelatedProjectCard from "Layout/Projects/RelatedProjects/RelatedProjectCard"
import "./RelatedProjects.scss"

const RelatedProjects = ({projects, headline}) => {
  const swiperSetting = {
    slidesPerView: 3,
    grabCursor: true,
    breakpoints: {
      // when window width is <= 767px
      767: {
        slidesPerView: 1
      }
    }
  }

  return (
    <div className="section section-related-projects pt-2 pt-lg-1 container-fluid bg-white">
      <div className="container">
        {projects.length > 0 && headline && (
          <div className="row section-headline">
            <div className="col-12">
              <h2 className="bracket-text mb-2">{headline}</h2>
            </div>
          </div>
        )}
        {projects.length > 3 ? (
          <ProjectSlider classes="row" settings={swiperSetting}>
            {projects.map(researchProject => {
              return (
                <div
                  className="project-slide col-12 col-md-4 pb-2 px-0 text-sm"
                  key={researchProject.node.title}
                >
                  <Link to={`/projects/${researchProject.node.slug}`}>
                    <div className="project-slide-inner">
                      <div className="image-header">
                        {researchProject.node.featured_media && researchProject.node.featured_media.localFile && researchProject.node.featured_media.localFile.childImageSharp.fixed.src && (
                          <img
                            src={researchProject.node.featured_media.localFile.childImageSharp.fixed.src}
                            alt={researchProject.node.featured_media.localFile.childImageSharp.fixed.originalName}
                          />
                        )}
                      </div>
                      <h3>{researchProject.node.title}</h3>
                      <span className="text-dot" />
                      <div className="project-description" dangerouslySetInnerHTML={{ __html: researchProject.node.excerpt }} />
                    </div>
                  </Link>
                </div>
              )
            })}
          </ProjectSlider>
        ) : (
          <div className="project-selection row">
            {projects.map(researchProject => {
              return (
                <RelatedProjectCard
                  item={researchProject.node}
                  key={researchProject.node.title}
                  classes="mb-2 mb-md-2"
                />
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default RelatedProjects
